import React from "react";
import { createRoot } from "react-dom/client";
import HistoryTimeline from "./HistoryTimeline";

export function mount(element) {
  if (!element || element.dataset.mounted === "true") return;
  const timeline = JSON.parse(element.dataset.timeline);
  element.dataset.mounted = "true";
  createRoot(element).render(<HistoryTimeline timeline={timeline} />);
}

function mountAll() {
  document.querySelectorAll("#history-timeline").forEach(mount);
}

document.addEventListener("DOMContentLoaded", mountAll);
document.addEventListener("turbo:load", mountAll);
